import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PageTitle from '../../components/common/PageTitle';
import { CenteredLayout } from '../../components/layouts';
import AdminNavbar from '../../components/layouts/AdminNavbar';
import { userRoleEnum } from '../../utils/enums';
import UserContext from '../AppRouter/UserContext';
import useExpectedHours from '../../hooks/useExpectedHours';
import ExpectedHoursList from '../../components/layouts/ExpectedHoursList';
import { monthNames } from '../../utils/consts';

const HoursChecker: React.FC = () => {
  const [selectedMonth, setSelectedMonth] = useState<string>(monthNames[new Date().getMonth()]);
  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());

  const {
    expectedHours,
    getExpectedHours,
    isLoading,
    acceptSettlement,
    rejectSettlement
  } = useExpectedHours(selectedMonth, selectedYear);
  const { userData } = useContext(UserContext);
  const location = useLocation();
  const previousRouteKeyRef = useRef<string | null>(null);

  useEffect(() => {
    const routeKey = `${location.pathname}${location.hash}`;
    const onHoursChecker =
      location.pathname.includes("hours-checker") ||
      location.hash.includes("hours-checker");
    const prev = previousRouteKeyRef.current;
    previousRouteKeyRef.current = routeKey;
    if (prev !== null && prev !== routeKey && onHoursChecker) {
      getExpectedHours();
    }
  }, [location.pathname, location.hash, getExpectedHours]);

  return (
    <>
      {userData.data.baseRole === userRoleEnum.Admin && <AdminNavbar />}
      <CenteredLayout>
        <PageTitle title="Rozliczenie godzin usług" />
        <div className="table-container">
          <ExpectedHoursList
            tableHeadTxt="Rozliczenie godzin usług"
            isLoading={isLoading}
            getMoreItems={getExpectedHours}
            items={expectedHours}
            selectedMonth={selectedMonth}
            selectedYear={selectedYear}
            setSelectedMonth={setSelectedMonth}
            setSelectedYear={setSelectedYear}
            acceptSettlement={acceptSettlement}
            rejectSettlement={rejectSettlement}
          />
        </div>
      </CenteredLayout>
    </>
  );
};

export default HoursChecker;
